<template>
  <div class="grid-view">
    <div class="main-content">
      <el-form
        label-width="133px"
        label-position="right"
      >
        <el-form-item :label="$t('CargoMsg.Cargo_CustomsDeclarationInformation')">
          <span style="color: #919191">{{ $t('CargoMsg.Cargo_QuantityWeightCubage') + $t('CargoMsg.Cargo_SubTotal') }}：{{ total }}</span>
        </el-form-item>
      </el-form>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="13011601"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="job.poItems || []"
          style="width:100%;height:200px;margin-top:5px"
          @gridReady="onGridReady"
        />
      </div>
      <div style="text-align: right;margin-bottom: 5px">
        <el-button :disabled="!isEditing" type="primary" no="1" @click="add">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
        <el-button :disabled="!isEditing" type="danger" no="2" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { roundHalfUp } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import URL from '@/api/urlTranslator'
import { PoItems } from '@/class/model/booking/PoItems'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { cache } from '@/utils/cacheManager'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'

export default {
  name: 'CustomsDeclaration',
  components: {
    CargoAgGridAdvanceSelectEditor
  },
  props: {
    job: { type: Object, required: true },
    isEditing: { type: Boolean, required: true },
    delPoItemsUuids: { type: Array, default: () => [] } // 待删除的 关单信息uuid
  },
  data() {
    return {
      URL,
      roundHalfUp,
      ColumnUtils,
      quantity: 0,
      grossWeight: 0.00,
      cubage: 0.00,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        singleClickEdit: true,
        suppressContextMenu: true,
        rowHeight: 32,
        unSortIcon: true,
        onCellFocused: (event) => {
          this.onUpCellFocused(event)
        },
        onRowClicked: this.onRowClicked,
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridCommonTextareaEditor
        },
        context: {
          componentParent: this
        }
      },
      gridApi: null,
      selectedRow: null,
      defaultContainerUsage: null,
      copyNum: ''
    }
  },
  computed: {
    columnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo',
          width: 100,
          editable: this.isEditing && (this.copyNum === 1 || !this.copyNum),
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 100,
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              min: 0,
              precision: 0
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'grossWeight',
          field: 'grossWeight',
          width: 100,
          valueFormatter: params => {
            return (Number(params.value) || 0).toFixed(3)
          },
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              min: 0,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 100,
          valueFormatter: params => {
            return (Number(params.value) || 0).toFixed(3)
          },
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              min: 0,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationCommissionNumber'),
          colId: 'cbaNumber',
          field: 'cbaNumber',
          width: 100
        }
      ]
      return columnDefs
    },
    total() {
      return this.quantity + '/' + this.grossWeight + '/' + this.cubage
    }
  },
  watch: {
    'job.poItems': {
      handler() {
        this.selectedRow = null
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedRow = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            this.selectedRow = node.data
          }
        })
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (event) {
        this.selectedRow = event.data
      }
    },
    onUpCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            node.setSelected(true)
            this.selectedRow = node.data
          }
        })
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    // 列编辑修改事件
    onCellChange(params) {
      const { node, colDef, data } = params
      switch (colDef.field) {
        case 'quantity':
          data.oldQuantity = Number(params.oldValue || 0)
          data.quantity = Number(params.newValue || 0)
          break
        case 'grossWeight':
          data.oldGrossWeight = Number(params.oldValue || 0)
          data.grossWeight = Number(params.newValue || 0)
          break
        case 'cubage':
          data.oldCubage = Number(params.oldValue || 0)
          data.cubage = Number(params.newValue || 0)
          break
      }
      this.poItemChange(data)
      // 计算 总【件、毛、体】
      this.calculation(colDef.field)
    },
    async init() {
      this.defaultContainerUsage = null
      if (this.job.uuid) {
        await new SeaExportJob(this.job).getPoItems()
        // 仅存在一条装箱信息，且【关单信息】为空
        if (this.job.containerUsages && this.job.containerUsages.length === 1 &&
          (!this.job.poItems || this.job.poItems.length === 0)) {
          this.job.isUsagedOldData = true
        } else {
          this.job.isUsagedOldData = false
        }
        //
        if (this.job.poItems && this.job.poItems.length > 0) {
          const distinctSet = new Set()
          for (const poItem of this.job.poItems) {
            distinctSet.add(poItem.containerUsageKey)
          }
          // 有没装箱的，且有已装箱的，此时defaultContainerUsage为空，新加的装箱信息不需要装进去
          if (distinctSet.size === 1 && this.job.containerUsages && this.job.containerUsages.length > 0) {
            this.defaultContainerUsage = this.job.containerUsages.find(p => p.uuid === this.job.poItems[0].containerUsageKey)
          }
        }
      }
      // 新增时，默认带出一条
      if (this.isEditing && !this.job.uuid && (!this.job.poItems || this.job.poItems.length === 0)) {
        this.add()
      }
      this.copyNum = LocalStorageUtilsNew.getConfiguration('COPY_NUM_INPUT' + this.job.lob)
      LocalStorageUtilsNew.setConfiguration('COPY_NUM_INPUT' + this.job.lob, '')
      this.refTotal()
    },
    add() {
      const poItem = new PoItems().fillDefaultValue().getData()
      poItem.purchaseCurrency = 'USD'
      poItem.deviceStatus = 0
      poItem.productiveYear = '不详'
      poItem.newOrUsed = ''
      poItem.jobUuid = this.job.uuid
      poItem.sequenceNo = this.job.poItems.length > 0 ? this.job.poItems.length + 1 : 1
      poItem.related = 0
      poItem.quantity = 0
      poItem.grossWeight = 0.0
      poItem.cubageActual = 0.0
      if (!this.job.poItems) {
        this.job.poItems = []
      }
      this.job.poItems.push(poItem)
      if (this.job.poItems.length === 1) {
        this.job.poItems[0].quantity = this.job.quantityActual || 0
        this.job.poItems[0].grossWeight = this.job.weightActual || 0.0
        this.job.poItems[0].cubage = this.job.cubageActual || 0.0
        this.refTotal()
      }
      this.poItemChange(poItem)
      this.$nextTick(() => {
        if (this.gridApi) {
          this.gridApi.deselectAll()
          const nodes = this.gridApi.getRenderedNodes()
          const lastNode = nodes[nodes.length - 1]
          lastNode.setSelected(true)
          this.selectedRow = lastNode.data
        }
      })
    },
    remove() {
      if (this.job.poItems.length === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CustomsDeclarationNotExist'))
        return
      }
      if (!this.selectedRow) {
        return
      }
      if (this.selectedRow.customsInfoUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CustomsDeclarationDeleteTip'))
        return
      }
      if (this.selectedRow.uuid) {
        this.delPoItemsUuids.push(this.selectedRow.uuid)
      }
      const key = this.job.poItems.findIndex(p => p === this.selectedRow)
      this.job.poItems.splice(key, 1)
      this.poItemChange(this.selectedRow, true)

      this.$nextTick(() => {
        // 计算 总【件、毛、体】
        this.calculation()
        // // 计算 装箱信息【件、毛、体】
        // this.calculationContainerUsage(this.selectedRow, DELETE.code)
        this.selectedRow = null
      })
    },
    // 修改件毛体
    calculation(colId) {
      let quantity = 0
      let cubage = 0
      let grossWeight = 0
      if (colId) {
        switch (colId) {
          case 'quantity':
            this.job.poItems.forEach(eve => {
              if (!eve.quantity) {
                eve.quantity = 0
              }
              quantity += parseInt(eve.quantity)
            })
            this.quantity = quantity
            break
          case 'grossWeight':
            this.job.poItems.forEach(eve => {
              if (!eve.grossWeight) {
                eve.grossWeight = 0.00
              }
              grossWeight += parseFloat(eve.grossWeight)
            })
            this.grossWeight = roundHalfUp(grossWeight, 3)
            break
          case 'cubage':
            this.job.poItems.forEach(eve => {
              if (!eve.cubage) {
                eve.cubage = 0.00
              }
              cubage += parseFloat(eve.cubage)
            })
            this.cubage = roundHalfUp(cubage, 3)
            break
          default:
            break
        }
      } else {
        this.job.poItems.forEach(eve => {
          if (eve.quantity == '') {
            eve.quantity = 0
          }
          if (eve.cubage == '') {
            eve.cubage = 0.00
          }
          if (!eve.grossWeight) {
            eve.grossWeight = 0.00
          }
          grossWeight += parseFloat(eve.grossWeight)
          cubage += parseFloat(eve.cubage)
          quantity += parseInt(eve.quantity)
        })
        this.quantity = quantity
        this.grossWeight = roundHalfUp(grossWeight, 3)
        this.cubage = roundHalfUp(cubage, 3)
      }
      this.syncQwcToJob()
    },
    // 在getSubmitData之前执行
    handleContainer() {
      // 老数据（已装箱且无关单信息的业务，补录关单信息）
      // (会将数据同步给业务实际件毛体，并触发ContainerUtil.containerJobSynQwc)
      if (this.job.isUsagedOldData) {
        if (this.job.poItems && this.job.poItems.length > 0) {
          for (const poItem of this.job.poItems) {
            poItem.containerUsageKey = this.job.containerUsages[0].uuid
          }
        }
        // viewPager传2，btnSave传false，多sono模式下，由汇总 关单信息的件毛体 到 实际件毛体
        ContainerUtil.refContainerUsageQwc(this.job, 2, false)
      }
    },
    // 每次【件毛体】变化时执行
    poItemChange(poItem, isDelete = false) {
      if (this.job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        // 为了将【关单信息】加到一个装箱信息中
        if (this.job.containerUsages && this.job.containerUsages.length > 0 && this.job.poItems && this.job.poItems.length > 0) {
          let usage = this.job.containerUsages.find(p => p.poItems && p.poItems.length > 0)
          if (!usage) {
            usage = this.job.containerUsages[0]
          }
          usage.poItems = this.job.poItems
          // 【关单信息】页签需要将这些poItems排查掉，否则创建重复
          this.job.poItems.forEach(p => {
            p.existInUsagedFlag = true
          })
          ContainerUtil.calcContainerUsageQWC(usage, this.job)
        }
        return
      }
      if (!this.job.uuid) {
        if (this.job.containerUsages && this.job.containerUsages.length === 1 && this.job.poItems && this.job.poItems.length > 0) {
          this.job.containerUsages[0].poItems = this.job.poItems
          // 【关单信息】页签需要将这些poItems排查掉，否则创建重复
          this.job.poItems.forEach(p => { p.existInUsagedFlag = true })
          const usage = this.job.containerUsages[0]
          ContainerUtil.calcContainerUsageQWC(usage, this.job)
        }
        return
      }
      // 新数据（已装箱且有关单信息的业务、未装箱的业务）
      // (会将数据同步给业务实际件毛体，不会触发ContainerUtil.containerJobSynQwc)
      if (!this.job.isUsagedOldData) {
        // 新增时，设置装箱关联字段（此时件毛体为0无需执行下面逻辑；或者件毛体是实际件毛体，此时没有装箱信息，无需执行下面逻辑）
        if (!isDelete && !poItem.uuid && !poItem.containerUsageKey) {
          if (this.defaultContainerUsage) {
            poItem.containerUsageKey = this.defaultContainerUsage.uuid
            if (!poItem.quantity && !poItem.grossWeight && !poItem.cubage) {
              return
            }
          }
        }
        if (poItem.containerUsageKey) {
          const usage = this.job.containerUsages.find(item => item.uuid === poItem.containerUsageKey)
          if (usage) {
            ContainerUtil.calcContainerUsageQWC(usage, this.job)
          }
        }
      }
    },
    syncQwcToJob() {
      // 只有一个so时，双向同步【件毛体】
      if (this.job.poItems && this.job.poItems.length === 1) {
        if (this.job.quantityActual !== this.job.poItems[0].quantity) {
          this.job.quantityActual = this.job.poItems[0].quantity
          this.$emit('quantityActualChange')
        }
        if (this.job.weightActual !== this.job.poItems[0].grossWeight) {
          this.job.weightActual = this.job.poItems[0].grossWeight
          this.$emit('weightActualChange')
        }
        if (this.job.cubageActual !== this.job.poItems[0].cubage) {
          this.job.cubageActual = this.job.poItems[0].cubage
          this.$emit('cubageActualChange')
        }
      }
      // 同步【关单号】到【订舱-》S/O No.】
      const soNos = []
      if (this.job.poItems && this.job.poItems.length > 0) {
        for (const poItem of this.job.poItems) {
          if (poItem.soNo) {
            soNos.push(poItem.soNo)
          }
        }
      }
      this.job.soNo = soNos.join('\n')
    },
    // 加载货物明细时，需要重新计算件毛体合计
    refTotal() {
      let quantity = 0
      let cubage = 0
      let grossWeight = 0
      if (this.job.poItems && this.job.poItems.length > 0) {
        this.job.poItems.forEach(eve => {
          if (!eve.quantity) {
            eve.quantity = 0
          }
          if (!eve.cubage) {
            eve.cubage = 0.00
          }
          if (!eve.grossWeight) {
            eve.grossWeight = 0.00
          }
          grossWeight += Number(eve.grossWeight)
          cubage += Number(eve.cubage)
          quantity += Number(eve.quantity)
        })
      }
      this.quantity = quantity
      this.grossWeight = NumberUtils.formatNumber(grossWeight, 3, true)
      this.cubage = NumberUtils.formatNumber(cubage, 3, true)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
